__webpack_require__.p = "https://bmidxblatviaplprod.netlify.app/";